module.exports = __webpack_public_path__ + "img/expovina_07.cf4a3730.jpg";